<template>
  <div class="">
    <el-select
      v-model="propertiesModel"
      @change="propertyChanged"
      autocomplete="new-password"
      :placeholder="placeholder ? placeholder : $t('COMMON.PROPERTIES')"
      :filterable="filterable"
      :multiple="true"
      :disabled="disabled"
      remote
      :remote-method="getProperties"
      :loading="loading"
    >
      <el-option
        v-if="showAll"
        :value="null"
        :label="placeholder ? placeholder : $t('COMMON.PROPERTIES')"
      >
      </el-option>
      <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
      </el-option>
      <el-option
        v-for="(property, key) in propertyList"
        :key="key"
        :value="property.id"
        :label="fullInformation
    ? `${property.property_number} - ${property.address}, ${property.city}, ${property.zipcode}${property.batch_numbers && property.batch_numbers.length ? ' - ' + property.batch_numbers.map(item => $numberFormat(item.value)).join(', ') : ''}`
    : property.property_number"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { Option, Select } from "element-ui";
import { difference } from "lodash";

export default {
  name: "properties-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    onlyByAuction: {
      type: Boolean,
      default: false,
      description: "Only by auction",
    },
    properties: {
      type: Array,
      default: () => [],
      description: "Warehouse id",
    },
    filterIdsNotIn: {
      type: Array,
      default: () => [],
      description: "Warehouse not in list id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterAuction: {
      type: String,
      default: null,
      description: "Auction id",
    },
    filterOwner: {
      type: String,
      default: null,
      description: "Contact id",
    },
    filterStatus: {
      type: String,
      default: null,
      description: "Status property",
    },
    placeholder: {
      type: String,
      default: null,
      description: "Placeholder",
    },
    isCollection: {
      type: Boolean,
      default: false,
      description: "isCollection",
    },
    fullInformation: {
      type: Boolean,
      default: false,
      description: "Display full information",
    },
    selectedLocations: {
      type: Array,
      default: () => [],
      description: "Location(s) id",
    },
  },

  data() {
    return {
      propertiesModel: [...this.properties].map((item) => item.id),
      propertyList: this.properties,
      loading: false,
    };
  },

  setup() {},

  created() {
    if(!this.onlyByAuction && (this.onlyByAuction && this.filterAuction)) {
      this.getProperties(null, this.property);
    }
  },

  methods: {
    async getProperties(query = null, ids = null) {
      try {
        this.loading = true;
        let params = {
          sort: "-created_at",
          filter: {
            ...(query ? { search: query } : {}),
            ...(ids?.length ? { ids: ids.map((item) => item.id) } : {}),
          },
          page: {
            number: 1,
            size: (!this.onlyByAuction ? 10 : 1000),
          },
          "fields[properties]": "property_number,address,city,zipcode,batch_numbers,status",
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }

        if (this.filterAuction) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              auctionId: this.filterAuction,
            },
          };
        }

        if (this.filterOwner) {
          params = {
            ...params,
            filter: { ...params.filter, owner: this.filterOwner },
          };
        }

        if (this.filterStatus) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              status: this.filterStatus,
            },
          };
        }

        if (this.filterIdsNotIn.length > 0) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              idsNotIn: this.filterIdsNotIn,
            },
          };
        }
        if(this.isCollection){
          await this.$store.dispatch("propertiesCollections/list", params);
          const propertyArr = await this.$store.getters["propertiesCollections/list"];
          this.propertyList = {};
          propertyArr.forEach((property) => {
            this.propertyList[property.id] = property;
          });
        }else{
          await this.$store.dispatch("properties/list", params);
          const propertyArr = await this.$store.getters["properties/list"];
          this.propertyList = {};
          propertyArr.forEach((property) => {
            this.propertyList[property.id] = property;
          });
        }

        if (this.selectedLocations) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              allowedLocations: this.selectedLocations.map((loc) => loc.id),
            },
          };
        }
        await this.$store.dispatch("properties/list", params);
        const propertyArr = await this.$store.getters["properties/list"];
        /*propertyArr.forEach((property) => {
          this.propertyList[] = property;
        });*/
        this.propertyList = propertyArr;
        if(this.onlyByAuction){
          this.propertiesModel = [...this.propertyList].map((item) => item.id);
          this.$emit('selectedProperties', this.propertiesModel);
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    propertyChanged(properties) {
      console.log(properties);
      this.$emit(
        "propertiesChanged",
        [...properties].map((item) => ({ type: "properties", id: item }))
      );
    },
  },

  watch: {
    properties(properties) {
      if (properties?.length) {
        const propertiesData = properties.map((item) => item.id);
        if (difference(propertiesData, this.locationsModel).length !== 0) {
          this.propertiesModel = propertiesData;
        }
      } else {
        this.propertiesModel = [];
      }
    },
    filterOrganization(filterOrganization) {
      this.getProperties();
    },
    filterAuction(filterAuction) {
      this.getProperties();
    },
    filterOwner(filterOwner) {
      this.getProperties();
    },
    filterStatus(filterStatus) {
      this.getProperties();
    },
    filterIdsNotIn(filterIdsNotIn) {
      this.getProperties();
    },
    selectedLocations(selectedLocations) {
      this.getProperties();
    },
  },
};
</script>
